"use client";

import Script from "next/script";

const RB2B_KEY = process.env.NEXT_PUBLIC_RB2B_KEY;

export function RB2BProvider() {
  if (!RB2B_KEY) {
    return null;
  }

  return (
    <Script id="rb2b" strategy="afterInteractive">
      {`!function(key){if(window.reb2b)return;window.reb2b={loaded:true};var s=document.createElement("script");s.async=true;s.src="https://ddwl4m2hdecbv.cloudfront.net/b/"+key+"/"+key+".js.gz";document.getElementsByTagName("script")[0].parentNode.insertBefore(s,document.getElementsByTagName("script")[0]);}("${RB2B_KEY}");`}
    </Script>
  );
}
